import axios from "axios";
import React, { useState, useEffect } from "react";

const RiseTicket = ({ onClose, product, user, compId, handleToast, isTech }) => {

 
// console.log(user);


const getCurrentDateTime = () => {
    const now = new Date();

    const istOffset = 5.5 * 60;
    const localOffset = now.getTimezoneOffset();
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

    const year = istTime.getFullYear();
    const month = String(istTime.getMonth() + 1).padStart(2, "0");
    const day = String(istTime.getDate()).padStart(2, "0");
    const hours = String(istTime.getHours()).padStart(2, "0");
    const minutes = String(istTime.getMinutes()).padStart(2, "0");
    const seconds = String(istTime.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  const [formData, setFormData] = useState({
    title: "",
    description: "",
   ticket_reference:'',
    contact_time:'',
    create_date: getCurrentDateTime(),
    category: product.category || "Hardware",
    sub_category: product.subCategory || "",
    priority: "Low",
    urgency: user.priority ?? "",
    attachment: null,
    assign_comp: user.assign_comp || compId,
    assigned_to: user.assigned_to ?? '',
    assigned_by: user.id,
  });

 

  const [tickets, setTickets] = useState([]);
const [newCategoryPopup, setNewCategoryPopup] = useState(false);
const [newCategory, setNewCategory] = useState("");


useEffect(() => {
  if (user && user.id) {
    setFormData((prev) => ({
      ...prev,
      assigned_by: user.id,
      assign_comp: user.assign_comp || compId,
      assigned_to: user.assigned_to ?? '',
    }));
  }
}, [user]);




    useEffect(() => {
    const getTicketsData = async () => {
      try {
        if (user.clientDetails) {
          const response = await axios.get(
            `https://api.dectwinservices.com/api/tickets/${user.id}`
          );
          setTickets(response.data);
        
          localStorage.setItem("tickets", JSON.stringify(response.data));
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/tickets"
          );
   
          setTickets(response.data);
          localStorage.setItem("tickets", JSON.stringify(response.data));
        }
      } catch (e) {
        user.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getTicketsData();
  }, [user]);
  

  const uniqueCategories = [
  ...new Set(tickets.map((ticket) => ticket.category).filter(Boolean))
];


  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  // Handle form submission
const handleSubmit = async (e) => {
  e.preventDefault();

  if(formData.urgency == ""){      handleToast({
        toastMsg: "Select Ticket Priority/ Urgency!",
        toastColor: "#FF9900",
      });
      return;
    }

  try {
    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("category", formData.category);
    formDataToSend.append("sub_category", formData.sub_category);
    formDataToSend.append("priority", formData.priority);
    formDataToSend.append("urgency", formData.urgency);
    formDataToSend.append("assign_comp", formData.assign_comp);
       formDataToSend.append("ticket_reference", formData.ticket_reference);
        formDataToSend.append("create_date", formData.create_date);
          formDataToSend.append("contact_time", formData.contact_time);
if (formData.assigned_to) {
  formDataToSend.append("assigned_to", formData.assigned_to);
}
// Don't append it at all if it's null/undefined
    formDataToSend.append("assigned_by", formData.assigned_by);
    formDataToSend.append("attachment", formData.attachment);

    const result = await axios.post(
      "https://api.dectwinservices.com/api/rise-ticket",
      formDataToSend,
      {
        headers: { "Content-Type": "multipart/form-data col-lg-4 col-md-6 col-12" },
      }
    );

  

    if (result.status === 200) {
      try {
        resetForm();
        handleToast({
          toastMsg: "Ticket Raised Successfully. Please wait for responses...",
          toastColor: "#4CAF50",
        });
        onClose();
      } catch (uiError) {
        console.error("UI update failed:", uiError);
      }
    } else {
      handleToast({
        toastMsg: "Unexpected server response. Please try again.",
        toastColor: "#FF9900",
      });
    }
  } catch (error) {
    console.error("Submission error:", error);
    handleToast({
      toastMsg: "Something went wrong! Please check data or internet.",
      toastColor: "#FF0000",
    });
  }
};

const resetForm = () => {
  setFormData({
    title: "",
    description: "",
    ticket_reference: "",
    contact_time: "",
    create_date: getCurrentDateTime(),
    category: product.category || "Hardware",
    sub_category: product.subCategory || "",
    priority: "Low",
    urgency: user.priority ?? "",
    attachment: null,
    assign_comp: user.assign_comp || compId,
    assigned_to: user.assigned_to ?? "",
    assigned_by: user.id,
  });

  setNewCategory("");
  setNewCategoryPopup(false);

  // Clear file input
  const fileInput = document.getElementById("attachment");
  if (fileInput) fileInput.value = "";
};


  return (
    
    <>
    
    <div>
      

        {/* Right Side - Ticket Form */}
        <div>
          {/* <h2>Raise a Ticket</h2> ticket-right*/}
          <form onSubmit={handleSubmit} className="row p-3">
      
            <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="title">Title/Issue/ Issue</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
                  name="title"
                  id="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Enter Ticket's Title"
                  required
                />
              </div>
            </div>
            

            <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
  <label htmlFor="category">Category</label>
  <div className="input-icon">
    <i className="bx bxs-category-alt"></i>
    <select
      name="category"
      id="category"
      value={formData.category}
      onChange={(e) => {
        if (e.target.value === "__add_new__") {
          setNewCategoryPopup(true);
        } else {
          handleChange(e);
        }
      }}
    >
                      <option value="">Select Category</option>
      {uniqueCategories.map((cat, idx) => (
        <option key={idx} value={cat}>
          {cat}
        </option>
      ))}
      <option value="__add_new__">+ Add New Category</option>
    </select>
  </div>
</div>

            <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="sub_category">Sub Category</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
                  name="sub_category"
                  id="sub_category"
                  value={formData.sub_category}
                  onChange={handleChange}
                  placeholder="Enter Sub Category"
                  required
                />
              </div>
            </div>

            <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="urgency">Priority/ Urgency</label>
              <div className="input-icon">
                <i className="bx bxs-category-alt"></i>
                <select
                  name="urgency"
                  id="urgency"
                  // value={formData.urgency}
                  value={formData.urgency}
                  onChange={handleChange}
                  required
                  disabled={isTech ? false : true}
                >
                <option value="">Select Priority</option>
                  <option value="1">Priority 1</option>  <option value="2">Priority 2</option>
                  <option value="3">Priority 3</option>   {/* {user.priority == '3' && (
                    <>
                  <option value="2">Priority 2</option>
                  <option value="3">Priority 3</option>
</>                  )}

{user.priority == '2'  && (
  <>

 
                  <option value="1">Priority 1</option>
                     <option value="2">Priority 2</option>
                      </>
)}


{ user.priority == '1' && (
                  <option value="1">Priority 1</option>
)} */}
                </select>
              </div>
            </div>




                <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="title">Preferred Contact Time</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
                  name="contact_time"
                  id="contact_time"
                  value={formData.contact_time}
                  onChange={handleChange}
                  placeholder="Enter Contact Time"
                  required
                />
              </div>
            </div>

                <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="title">Prevoius Ticket Reference</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
                  name="ticket_reference"
             
                  value={formData.ticket_reference}
                  onChange={handleChange}
                  placeholder="Enter Ticket's Title"
                  required
                />
              </div>
            </div>

              <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="title">Issue Date</label>
              <div className="input-icon">
                {/* <i className="bx bxs-layer"></i> */}
                <input
                  type="datetime-local"
                  name="create_date"
                  value={formData.create_date}
                  onChange={handleChange}
                 max={getCurrentDateTime()} placeholder="Enter Ticket's Title"
                  required
              disabled={isTech ? false : true}
                />
              </div>
            </div>

           
                        <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="attachment">Attachments</label>
              <div className="input-icon">
                <i className="bx bxs-image"></i>
                <input
                  type="file"
                  name="attachment"
                  id="attachment"
                  onChange={handleChange}
                  // accept="image/*"
                />
              </div>
            </div>

            <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="description">Ticket Description</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <textarea
                  name="description"
                  id="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Enter Ticket's Description"
                  required
                />
              </div>
            </div>

               <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="description">User</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                 <input
                  type="text"
                  value={user.name}
                  placeholder="User Name"
                  readonly
                />
              </div>
            </div>

            
               <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="description">User ID</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                 <input
                  type="text"
                  value={user.staff_id}
                  placeholder="User ID"
                  readonly
                />
              </div>
            </div>




               <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="description">Email</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                 <input
                  type="text"
                  value={user.email}
                  placeholder="User Name"
                  readonly
                />
              </div>
            </div>



               <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="description">User Contact</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                 <input
                  type="text"
                  value={user.contact}
                  placeholder="User Contact"
                  readonly
                />
              </div>
            </div>

            
               <div className="form-data col-lg-4 col-md-6 col-12 ticket-column">
              <label htmlFor="description">User Department</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                 <input
                  type="text"
                  value={user.department}
                  placeholder="User Name"
                  readonly
                />
              </div>
            </div>
            <br />
    

<div className="ticket-column"></div>
<div className="ticket-column"></div>

          <div className="btn-group d-flex mt-2" style={{ justifyContent: "end" }}>
              <button className="button-85" type="submit" >
                Submit Ticket
              </button></div>

  </form>
        </div>


      {newCategoryPopup && (
  <div className="ticket-popup">
    <div className="popup-content" style={{display: 'block', padding: '1.8em'}}>
      <h3>Add New Category</h3>


            <div className="form-data" style={{margin: '0.8em 0em'}}>
              <label htmlFor="title">Category</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
      <input
        type="text"
        value={newCategory}
        onChange={(e) => setNewCategory(e.target.value)}
        placeholder="Enter new category name"
      />
              </div>
            </div>


            <div className="btn-group d-flex" style={{ justifyContent: "end" }}>
        <button
          onClick={() => {
            setNewCategoryPopup(false);
            setNewCategory("");
          }}
          className="add-btn"
        >
          Cancel
        </button>              &nbsp;&nbsp;&nbsp;&nbsp;
        <button
          onClick={() => {
            if (newCategory.trim()) {
              setFormData({ ...formData, category: newCategory });
              setTickets([...tickets, { ...formData, category: newCategory }]); // optional, update local ticket list
              setNewCategory("");
              setNewCategoryPopup(false);
            }
          }}
          className="add-btn"
        >
          Save
        </button>            </div>

      {/* <div style={{ marginTop: '1em' }}>
        <button
          onClick={() => {
            if (newCategory.trim()) {
              setFormData({ ...formData, category: newCategory });
              setTickets([...tickets, { ...formData, category: newCategory }]); // optional, update local ticket list
              setNewCategory("");
              setNewCategoryPopup(false);
            }
          }}
          className="add-btn"
        >
          Save
        </button>
        &nbsp;
        <button
          onClick={() => {
            setNewCategoryPopup(false);
            setNewCategory("");
          }}
          className="add-btn"
        >
          Cancel
        </button>
      </div> */}
    </div>
  </div>
)}

    </div>
    </>
  );
};

export default RiseTicket;
